"use client";

import { StartScreen } from "@/components/home/start-screen";
import { useQuiz } from "@/hooks";

export function HomeClient() {
  const { hasProgress, isComplete, isHydrated, resetQuiz } = useQuiz();

  return (
    <div className="min-h-screen bg-background">
      <main className="mx-auto max-w-4xl px-4 py-8">
        <StartScreen
          hasSavedProgress={isHydrated ? hasProgress : false}
          isQuizComplete={isHydrated ? isComplete : false}
          onReset={resetQuiz}
        />
      </main>
    </div>
  );
}
